import React from 'react';
import { Result, Button, Typography, Space } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const Error = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <Result
        status="warning"
        icon={<WarningOutlined style={{ color: '#faad14' }} />}
        title={<Title level={2}>404 - Page Not Found</Title>}
        subTitle={
          <Paragraph type="secondary">
            Sorry, the page you are looking for does not exist. It might have been moved or deleted.
          </Paragraph>
        }
        extra={
          <Space direction="vertical" size="large">
            <Button type="primary" onClick={() => navigate('/')}>
              Go Home
            </Button>
            <Button onClick={() => navigate(-1)}>
              Go Back
            </Button>
          </Space>
        }
      />
    </div>
  );
};

export default Error;